"use strict";
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Store } from "../../Store";
import { getStoredProjectFile } from "../../utils/storage";

export default function ProjectRoute({ children }) {
    const { state } = useContext(Store);
    const { projectFile } = state;

    if (projectFile && projectFile.id) {
        return children;
    }

    const savedProject = getStoredProjectFile();
    if (savedProject) {
        return children;
    }

    return <Navigate to="/landing" />;
}
